import request from '@/utils/request';
import type { API } from '@/types';

export const getDressTypeList = (): Promise<API.DressType[]> => {
  return request.get('/api/dress/type', { params: {} }) as unknown as Promise<API.DressType[]>;
};

export const batchAddDress = (data: API.BatchCreateDressRequest): Promise<API.BatchCreateDressResult> => {
  return request.post('/api/dress/user/batch-add', data) as unknown as Promise<API.BatchCreateDressResult>;
};
